var callbacksMap = new Map();
export { callbacksMap };
